<script>
    import DibbleJS from "../../../dibble";

    export default {
        name: "UsersListSearch",
        props: {
            showAddButton: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                dibbleJs: DibbleJS,
                searchingText: ''
            }
        },
        methods: {
            showAddUserModal() {
                this.$emit('showAddUserModal')
            },
            searchForUser() {
                this.$emit('searchUser', this.searchingText)
            }
        }
    }
</script>
<template src="../template/sub-components/users-list-search.html"></template>
<style scoped>

</style>
